import React from "react";
import { useController } from "react-hook-form";
import { Text } from "../../../../../../Inputs/react-hook-form";
import {
  getSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../form/form";
import { FieldsList } from "../FieldsTab/FieldsList";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";

export function ObjectFieldTemplateSettings({
  fieldPath,
  isReadOnly,
}: InputSettingsFormProps) {
  const { register } = useBuilderFormContext();

  const titlePropertyFormPath = getSchemaPropertyFormPath(fieldPath, "title");
  const titleController = useController({
    name: titlePropertyFormPath,
  });
  const errorMessage = titleController.fieldState.error?.message;

  return (
    <WidgetSettingsContainer>
      <Text
        label="Title"
        error={errorMessage}
        disabled={isReadOnly}
        required
        data-testid="field-group-title-input"
        {...register(titlePropertyFormPath)}
      />
      {!isReadOnly && <FieldsList atFieldPath={fieldPath} />}
    </WidgetSettingsContainer>
  );
}
